var React = require('react');

function Connect90 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0C551.383 0 1000 453.074 1000 1010L420.181 1010H333.333C333.333 824.077 184.094 673.355 0 673.355L0 0Z","fill":"currentColor"}));
}

Connect90.defaultProps = {"width":"1000","height":"1010","viewBox":"0 0 1000 1010","fill":"none"};

module.exports = Connect90;

Connect90.default = Connect90;
